module.exports = __webpack_public_path__ + "img/device-monitor.9a0f3225.svg";